export default "/_next/static/images/dcf164ad18c5da121a539a1ae399290f.png";